// FOOD page — daily КБЖУ diary with meal sections, ported from the original app's FOOD
// section. Composition is always edited via ingredient rows (grams), never via direct
// КБЖУ fields — macros are always computed from products.
import { S, MEALS, MEAL_LABELS } from '../state.js';
import { save } from '../lib/sync.js';
import { today, fmtDate, shiftDate } from '../lib/dates.js';
import { n0, n1, escHtml } from '../lib/format.js';
import { dayKbzhu, kbzhuBar, ingList, dishList } from '../lib/calc.js';
import { IC } from '../lib/icons.js';
import { openSheet, closeSheet } from '../lib/modal.js';
import { showToast } from '../components/toast.js';
import { requireArchivePassword } from '../components/passwordDialog.js';
import { registerPage, goNav, curPage } from '../lib/router.js';
import { renderHome } from './home.js';
import { editDish } from './dishes.js';
import { openDatePicker } from '../components/datePicker.js';

let foodDate = today();
export function getFoodDate() { return foodDate; }

export function shiftFoodDate(n) {
  foodDate = shiftDate(foodDate, n);
  renderFood();
}
export function setFoodDate(d) {
  foodDate = d;
  renderFood();
}
export function goToFoodDate(d) {
  foodDate = d;
  goNav('food');
}

export function openFoodDatePicker() {
  openDatePicker(foodDate, d => { foodDate = d; renderFood(); }, d => {
    const fl = S.foodLog[d];
    return !!(fl && Object.values(fl).some(arr => arr && arr.length));
  });
}

export function renderFood() {
  document.getElementById('foodDateLabel').textContent = fmtDate(foodDate);
  const kbzhu = dayKbzhu(foodDate);
  document.getElementById('fK').textContent = kbzhu.k;
  document.getElementById('fP').textContent = kbzhu.p;
  document.getElementById('fF').textContent = kbzhu.f;
  document.getElementById('fC').textContent = kbzhu.c;
  document.getElementById('foodKbzhuBars').innerHTML = kbzhuBar(kbzhu.k, kbzhu.p, kbzhu.f, kbzhu.c);

  const fl = S.foodLog[foodDate] || {};
  let html = '';
  MEALS.forEach(m => {
    const items = fl[m] || [];
    const mkcal = items.reduce((s, i) => s + (i.k || 0), 0);
    html += `<div class="meal-section meal-${m}">
      <div class="meal-section-hd">
        <span class="meal-section-name">${MEAL_LABELS[m]}</span>
        <span class="meal-section-kcal">${n0(mkcal)} ккал</span>
      </div>`;
    if (items.length === 0) {
      html += `<div style="padding:8px 0;font-size:12px;color:var(--text3)">Пусто</div>`;
    } else {
      items.forEach((it, i) => {
        const eaten = it.eaten !== false;
        html += `<div class="meal-item" style="${eaten ? '' : 'opacity:.5'}">
          <label style="display:flex;align-items:center;flex-shrink:0;margin-right:2px;cursor:pointer" title="${eaten ? 'Съедено' : 'Ещё не съедено'}">
            <input type="checkbox" ${eaten ? 'checked' : ''} style="width:18px;height:18px;accent-color:var(--accent);cursor:pointer" onchange="toggleFoodEaten('${m}',${i},this.checked)">
          </label>
          <div class="meal-body" onclick="openFoodEdit('${m}',${i})" style="cursor:pointer;flex:1">
            <div class="meal-name">${escHtml(it.name)}${eaten ? '' : ' <span class="tag" style="margin-left:4px">план</span>'}</div>
            <div class="meal-meta">${it.g || 0}г · Б ${n1(it.p || 0)} · Ж ${n1(it.f || 0)} · У ${n1(it.c || 0)}</div>
          </div>
          <div class="meal-kcal">${n0(it.k || 0)}</div>
          <button class="meal-del" onclick="delFoodItem('${m}',${i})" title="Удалить">${IC.trash}</button>
        </div>`;
      });
    }
    html += `</div>`;
  });
  document.getElementById('foodList').innerHTML = html;
}
registerPage('food', renderFood);

function maybeRefreshHome() {
  if (foodDate === today() && curPage === 'home') renderHome();
}

export function toggleFoodEaten(meal, idx, val) {
  const it = S.foodLog[foodDate]?.[meal]?.[idx];
  if (!it) return;
  it.eaten = val;
  save(true);
  renderFood();
  maybeRefreshHome();
}

export function delFoodItem(meal, idx) {
  if (!S.foodLog[foodDate]) return;
  const doDelete = () => {
    S.foodLog[foodDate][meal].splice(idx, 1);
    save(true); renderFood();
    maybeRefreshHome();
  };
  if (S.archivedDays.includes(foodDate)) requireArchivePassword(doDelete);
  else doDelete();
}

// ── ADD/EDIT FOOD SHEET ──
let activeMeal = 'breakfast';
let fEditIngs = []; // [{name, per100:{k,p,f,c}, grams}]
let fNoShrink = false;
let fIngSelected = null;
let fReplaceTargetIndex = null;
let fEaten = true;
let editingFood = null; // {meal, idx} when editing an existing entry

export function setActiveMeal(m, btn) {
  activeMeal = m;
  document.querySelectorAll('#mealTypeGroup .toggle-btn').forEach(b => b.classList.remove('on'));
  btn.classList.add('on');
}

export function toggleFEaten(val) {
  fEaten = val;
  document.getElementById('fEatenBtn').classList.toggle('on', val);
  document.getElementById('fPlannedBtn').classList.toggle('on', !val);
}

export function openAddFood() {
  editingFood = null;
  fEditIngs = [];
  fIngSelected = null;
  fReplaceTargetIndex = null;
  document.getElementById('fIngAddBtn').textContent = '+ Добавить';
  document.getElementById('fIngCancelReplace').style.display = 'none';
  document.getElementById('fIngAddRow').style.display = 'none';
  document.getElementById('fIngAddToggleBtn').textContent = '+ Добавить продукт';
  document.getElementById('foodNameInp').value = '';
  document.getElementById('foodSugg').style.display = 'none';
  document.getElementById('fIngInp').value = '';
  document.getElementById('fIngG').value = '';
  document.getElementById('fIngSugg').style.display = 'none';
  document.getElementById('fCookedInp').value = '';
  document.getElementById('fCookedInp').disabled = false;
  document.getElementById('fCookedInp').style.opacity = '';
  fNoShrink = false;
  document.getElementById('fNoShrinkChk').checked = false;
  document.getElementById('fPortionAllChk').checked = true;
  document.getElementById('fPortionGramsRow').style.display = 'none';
  document.getElementById('fPortionGramsInp').value = '';
  toggleFEaten(false);
  fRenderIngTable();
  const now = new Date().getHours();
  activeMeal = now < 10 ? 'breakfast' : now < 14 ? 'lunch' : now < 20 ? 'dinner' : 'snacks';
  document.getElementById('mealTypeGroup').innerHTML = MEALS.map(m =>
    `<button class="toggle-btn ${m === activeMeal ? 'on' : ''}" onclick="setActiveMeal('${m}',this)">${MEAL_LABELS[m]}</button>`
  ).join('');
  openSheet('shAddFood');
}

export function openFoodEdit(meal, idx) {
  const it = S.foodLog[foodDate][meal][idx];
  activeMeal = meal;
  fReplaceTargetIndex = null;
  document.getElementById('fIngAddBtn').textContent = '+ Добавить';
  document.getElementById('fIngCancelReplace').style.display = 'none';
  document.getElementById('fIngAddRow').style.display = 'none';
  document.getElementById('fIngAddToggleBtn').textContent = '+ Добавить продукт';
  document.getElementById('mealTypeGroup').innerHTML = MEALS.map(m =>
    `<button class="toggle-btn ${m === activeMeal ? 'on' : ''}" onclick="setActiveMeal('${m}',this)">${MEAL_LABELS[m]}</button>`
  ).join('');
  document.getElementById('foodNameInp').value = it.name;
  document.getElementById('foodSugg').style.display = 'none';
  toggleFEaten(it.eaten !== false);
  if (it.ingredients && it.ingredients.length) {
    fEditIngs = JSON.parse(JSON.stringify(it.ingredients));
  } else {
    const g = it.g || 100;
    fEditIngs = [{ name: it.name, per100: { k: n1((it.k || 0) * 100 / g), p: n1((it.p || 0) * 100 / g), f: n1((it.f || 0) * 100 / g), c: n1((it.c || 0) * 100 / g) }, grams: g }];
  }
  fRenderIngTable();
  const rawSum = fEditIngs.reduce((s, ing) => s + ing.grams, 0);
  fNoShrink = !!it.noShrink;
  document.getElementById('fNoShrinkChk').checked = fNoShrink;
  document.getElementById('fCookedInp').disabled = fNoShrink;
  document.getElementById('fCookedInp').style.opacity = fNoShrink ? '.6' : '';
  document.getElementById('fCookedInp').value = n0(it.cookedWeight || rawSum);
  document.getElementById('fPortionAllChk').checked = it.portionAll !== undefined ? it.portionAll : true;
  document.getElementById('fPortionGramsInp').value = it.g || '';
  document.getElementById('fPortionGramsRow').style.display = document.getElementById('fPortionAllChk').checked ? 'none' : '';
  fRecalcPortion();
  openSheet('shAddFood');
  editingFood = { meal, idx };
}

export function cancelAddFood() {
  editingFood = null;
  closeSheet('shAddFood');
}

export function fToggleAddRow() {
  const row = document.getElementById('fIngAddRow');
  const open = row.style.display === 'none';
  row.style.display = open ? '' : 'none';
  document.getElementById('fIngAddToggleBtn').textContent = open ? '− Скрыть' : '+ Добавить продукт';
  if (open) document.getElementById('fIngInp').focus();
}

export function fStartReplaceIng(i) {
  fReplaceTargetIndex = i;
  document.getElementById('fIngInp').value = '';
  document.getElementById('fIngG').value = '';
  document.getElementById('fIngAddBtn').textContent = 'Заменить';
  document.getElementById('fIngCancelReplace').style.display = '';
  document.getElementById('fIngAddRow').style.display = '';
  document.getElementById('fIngAddToggleBtn').textContent = '− Скрыть';
  fRenderIngTable();
  document.getElementById('fIngInp').focus();
}

export function fCancelReplaceIng() {
  fReplaceTargetIndex = null;
  fIngSelected = null;
  document.getElementById('fIngInp').value = '';
  document.getElementById('fIngG').value = '';
  document.getElementById('fIngAddBtn').textContent = '+ Добавить';
  document.getElementById('fIngCancelReplace').style.display = 'none';
  document.getElementById('fIngAddRow').style.display = 'none';
  document.getElementById('fIngAddToggleBtn').textContent = '+ Добавить продукт';
  fRenderIngTable();
}

export function foodNameSearch() {
  const q = document.getElementById('foodNameInp').value.trim().toLowerCase();
  const sugg = document.getElementById('foodSugg');
  if (q.length < 1) { sugg.style.display = 'none'; return; }
  const dishes = dishList().filter(d => d.name.toLowerCase().includes(q))
    .sort((a, b) => (b.favorite ? 1 : 0) - (a.favorite ? 1 : 0));
  const ings = ingList().filter(d => d.name.toLowerCase().includes(q));
  const all = [
    ...dishes.map(d => ({ name: d.name, k: d.k, p: d.p, f: d.f, c: d.c, ingredients: d.ingredients, cookedWeight: d.cookedWeight, noShrink: d.noShrink, src: 'блюдо', favorite: d.favorite })),
    ...ings.map(i => ({ name: i.name, k: i.k, p: i.p, f: i.f, c: i.c, ingredients: null, src: 'продукт' })),
  ].slice(0, 8);
  if (all.length === 0) { sugg.style.display = 'none'; return; }
  sugg.innerHTML = all.map((x, i) => `
    <div class="sugg-item" onclick="selectFoodItem(${i})">
      <div class="sugg-item-name">${x.favorite ? '★ ' : ''}${escHtml(x.name)} <span style="font-size:10px;color:var(--text3)">${x.src}</span></div>
      <div class="sugg-item-meta">${x.k} ккал · Б ${x.p} · Ж ${x.f} · У ${x.c} / 100г</div>
    </div>
  `).join('');
  sugg._data = all;
  sugg.style.display = 'block';
}

export function selectFoodItem(i) {
  const sugg = document.getElementById('foodSugg');
  const item = sugg._data[i];
  document.getElementById('foodNameInp').value = item.name;
  sugg.style.display = 'none';

  // If this exact dish was actually logged before with custom ingredient amounts/cooked
  // weight (a real batch you made, not the dish's generic base recipe), pick that back up
  // instead of resetting to the database default — e.g. "ate half the soup yesterday,
  // logging the rest today" shouldn't make you re-enter the whole recipe from scratch.
  const remembered = S.lastRecipe[item.name];
  const isRealRecipe = (remembered ? remembered.ingredients.length : (item.ingredients || []).length) > 1;

  if (remembered) {
    fEditIngs = JSON.parse(JSON.stringify(remembered.ingredients));
  } else if (item.ingredients && item.ingredients.length) {
    fEditIngs = JSON.parse(JSON.stringify(item.ingredients));
  } else {
    const g = S.lastGrams[item.name] || 100;
    fEditIngs = [{ name: item.name, per100: { k: item.k, p: item.p, f: item.f, c: item.c }, grams: g }];
  }
  const rawSum = fEditIngs.reduce((s, ing) => s + ing.grams, 0);

  let noShrinkResolved, cooked;
  if (remembered) {
    noShrinkResolved = remembered.noShrink;
    cooked = n0(remembered.noShrink ? rawSum : (remembered.cookedWeight || rawSum));
  } else {
    const rememberedCooked = S.lastGrams['готово:' + item.name];
    cooked = n0(rememberedCooked || item.cookedWeight || rawSum);
    // Prefer the dish's own explicit "считать сырым" setting (set once when the dish was
    // created/edited) over guessing from the numbers — only guess when it was never set.
    noShrinkResolved = item.noShrink !== undefined
      ? item.noShrink
      : (!isRealRecipe || Math.abs(cooked - rawSum) <= Math.max(1, rawSum * 0.005));
  }
  fNoShrink = noShrinkResolved;
  document.getElementById('fNoShrinkChk').checked = fNoShrink;
  document.getElementById('fCookedInp').disabled = fNoShrink;
  document.getElementById('fCookedInp').style.opacity = fNoShrink ? '.6' : '';
  document.getElementById('fCookedInp').value = fNoShrink ? n0(rawSum) : cooked;
  document.getElementById('fPortionAllChk').checked = true;
  document.getElementById('fPortionGramsRow').style.display = 'none';
  fRenderIngTable();
}

export function fIngSearch() {
  const q = document.getElementById('fIngInp').value.trim().toLowerCase();
  const sugg = document.getElementById('fIngSugg');
  if (q.length < 1) { sugg.style.display = 'none'; return; }
  const list = ingList().filter(x => x.name.toLowerCase().includes(q)).slice(0, 8);
  if (!list.length) { sugg.style.display = 'none'; return; }
  sugg.innerHTML = list.map((x, i) => `
    <div class="sugg-item" onclick="fIngSelect(${i})">
      <div class="sugg-item-name">${escHtml(x.name)}</div>
      <div class="sugg-item-meta">${x.k} ккал · Б ${x.p} · Ж ${x.f} · У ${x.c} / 100г</div>
    </div>`).join('');
  sugg._data = list;
  sugg.style.display = 'block';
}

export function fIngSelect(i) {
  const sugg = document.getElementById('fIngSugg');
  fIngSelected = sugg._data[i];
  document.getElementById('fIngInp').value = fIngSelected.name;
  const remembered = S.lastGrams[fIngSelected.name];
  if (remembered) document.getElementById('fIngG').value = remembered;
  sugg.style.display = 'none';
}

export function fIngAdd() {
  if (!fIngSelected || fIngSelected.name !== document.getElementById('fIngInp').value.trim()) {
    const found = ingList().find(x => x.name === document.getElementById('fIngInp').value.trim());
    if (found) fIngSelected = found; else { showToast('Выбери продукт из списка'); return; }
  }

  if (fReplaceTargetIndex !== null) {
    const idx = fReplaceTargetIndex;
    const keepGrams = fEditIngs[idx].grams;
    fEditIngs[idx] = { name: fIngSelected.name, per100: { k: fIngSelected.k, p: fIngSelected.p, f: fIngSelected.f, c: fIngSelected.c }, grams: keepGrams };
    fCancelReplaceIng();
    return;
  }

  const g = parseFloat(document.getElementById('fIngG').value) || S.lastGrams[fIngSelected.name] || 100;
  fEditIngs.push({ name: fIngSelected.name, per100: { k: fIngSelected.k, p: fIngSelected.p, f: fIngSelected.f, c: fIngSelected.c }, grams: g });
  document.getElementById('fIngInp').value = '';
  document.getElementById('fIngG').value = '';
  fIngSelected = null;
  if (fEditIngs.length === 1 && !parseFloat(document.getElementById('fCookedInp').value)) {
    document.getElementById('fCookedInp').value = g;
  }
  document.getElementById('fIngAddRow').style.display = 'none';
  document.getElementById('fIngAddToggleBtn').textContent = '+ Добавить продукт';
  fRenderIngTable();
}

export function fDelIng(i) { fEditIngs.splice(i, 1); fRenderIngTable(); }

// A component dish used in this entry (e.g. "фарш" inside "пельмени") may have been edited
// since this row was added/remembered (see S.lastRecipe in selectFoodItem) — always pull its
// live per100 before displaying/saving, so the shown КБЖУ never lags behind the dish's actual
// current recipe. Rows saved before dish-tagging existed (or before a rename) won't carry
// isDish/dishId — fall back to matching by name and backfill the tag so future renders (and
// cascadeUpdateDish) can go straight to the id.
function refreshDishRows() {
  fEditIngs.forEach(ing => {
    const src = (ing.dishId && dishList().find(x => x.id === ing.dishId)) || dishList().find(x => x.name === ing.name);
    if (!src) return;
    ing.per100 = { k: src.k, p: src.p, f: src.f, c: src.c };
    ing.isDish = true; ing.dishId = src.id;
  });
}

// Jump to editing a component dish's own recipe (e.g. tap the edit icon on "фарш" while
// composing "пельмени") — mirrors dEditNestedDish in pages/dishes.js. The dish editor is a
// separate modal (higher z-index than this sheet) so it opens ON TOP without closing or
// losing anything here; once it's closed again (saved or cancelled), the ingredient table
// re-renders to pick up the component's fresh КБЖУ via refreshDishRows() above.
export function fEditNestedDish(dishId) {
  const d = dishList().find(x => x.id === dishId);
  if (!d) return;
  editDish(dishId);
  const dishModal = document.getElementById('shAddDish');
  const observer = new MutationObserver(() => {
    if (!dishModal.classList.contains('open')) {
      observer.disconnect();
      fRenderIngTable();
    }
  });
  observer.observe(dishModal, { attributes: true, attributeFilter: ['class'] });
}

function fRenderIngTable() {
  refreshDishRows();
  const tbody = document.getElementById('fIngList');
  const hasIngs = fEditIngs.length > 0;
  document.getElementById('fIngEmpty').style.display = hasIngs ? 'none' : '';
  document.getElementById('fIngActiveArea').style.display = hasIngs ? '' : 'none';
  tbody.innerHTML = fEditIngs.map((ing, i) => {
    const k = n0(ing.per100.k * ing.grams / 100), p = n1(ing.per100.p * ing.grams / 100);
    const f = n1(ing.per100.f * ing.grams / 100), c = n1(ing.per100.c * ing.grams / 100);
    const isReplacing = fReplaceTargetIndex === i;
    return `<tr style="border-bottom:1px solid var(--border);${isReplacing ? 'background:var(--accent-bg)' : ''}">
      <td style="padding:5px 4px;font-size:12px;white-space:nowrap">${ing.isDish ? `<button onclick="fEditNestedDish('${ing.dishId}')" class="dish-btn" style="padding:1px;vertical-align:middle" title="Открыть рецепт «${escHtml(ing.name)}»">${IC.edit}</button> ` : ''}${escHtml(ing.name)}${isReplacing ? ' <span style="color:var(--accent);font-size:10px">(меняю…)</span>' : ''}</td>
      <td style="padding:3px 4px;text-align:right">
        <input type="number" value="${ing.grams}" min="1" style="width:52px;border:1.5px solid var(--border);border-radius:var(--r-xs);padding:3px 5px;font-size:12px;text-align:right;background:var(--surface);color:var(--text)"
          onchange="fSetIngGrams(${i},this.value)">
      </td>
      <td style="padding:5px 4px;text-align:right;color:var(--amber)">${k}</td>
      <td style="padding:5px 4px;text-align:right">${p}</td>
      <td style="padding:5px 4px;text-align:right">${f}</td>
      <td style="padding:5px 4px;text-align:right">${c}</td>
      <td style="padding:3px 0;text-align:center;white-space:nowrap"><button onclick="fStartReplaceIng(${i})" class="dish-btn" title="Заменить продукт">${IC.edit}</button><button onclick="fDelIng(${i})" class="dish-btn" title="Удалить">${IC.trash}</button></td>
    </tr>`;
  }).join('');
  let tk = 0, tp = 0, tf = 0, tc = 0, tg = 0;
  fEditIngs.forEach(ing => { const m = ing.grams / 100; tk += ing.per100.k * m; tp += ing.per100.p * m; tf += ing.per100.f * m; tc += ing.per100.c * m; tg += ing.grams; });
  document.getElementById('fTotalG').textContent = n0(tg);
  document.getElementById('fTotalK').textContent = n0(tk);
  document.getElementById('fTotalP').textContent = n1(tp);
  document.getElementById('fTotalF').textContent = n1(tf);
  document.getElementById('fTotalC').textContent = n1(tc);
  document.getElementById('fPortionPanel').style.display = hasIngs ? '' : 'none';
  if (fNoShrink) document.getElementById('fCookedInp').value = n0(tg);
  fRecalcPortion();
}

export function fSetIngGrams(i, val) {
  fEditIngs[i].grams = parseFloat(val) || 1;
  fRenderIngTable();
}

export function fTogglePortionAll() {
  const checked = document.getElementById('fPortionAllChk').checked;
  document.getElementById('fPortionGramsRow').style.display = checked ? 'none' : '';
  fRecalcPortion();
}

export function fToggleNoShrink() {
  fNoShrink = document.getElementById('fNoShrinkChk').checked;
  const cookedInp = document.getElementById('fCookedInp');
  cookedInp.disabled = fNoShrink;
  cookedInp.style.opacity = fNoShrink ? '.6' : '';
  if (fNoShrink) {
    const tg = fEditIngs.reduce((s, ing) => s + ing.grams, 0);
    cookedInp.value = n0(tg);
  }
  fRecalcPortion();
}

export function fRecalcPortion() {
  let tk = 0, tp = 0, tf = 0, tc = 0, tg = 0;
  fEditIngs.forEach(ing => { const m = ing.grams / 100; tk += ing.per100.k * m; tp += ing.per100.p * m; tf += ing.per100.f * m; tc += ing.per100.c * m; tg += ing.grams; });
  const cookedInp = document.getElementById('fCookedInp');
  const cooked = fNoShrink ? (tg || 1) : (parseFloat(cookedInp.value) || tg || 1);
  const portionAll = document.getElementById('fPortionAllChk').checked;
  let portion;
  if (portionAll) {
    portion = cooked;
    document.getElementById('fPortionGramsInp').value = n0(cooked);
  } else {
    portion = parseFloat(document.getElementById('fPortionGramsInp').value) || 0;
  }
  const m = cooked > 0 ? portion / cooked : 0;
  document.getElementById('fPortionK').textContent = n0(tk * m);
  document.getElementById('fPortionP').textContent = n1(tp * m);
  document.getElementById('fPortionF').textContent = n1(tf * m);
  document.getElementById('fPortionC').textContent = n1(tc * m);
}

export function addFoodEntry() {
  const name = document.getElementById('foodNameInp').value.trim();
  if (!name) { showToast('Введи название'); return; }
  if (!fEditIngs.length) { showToast('Добавь хотя бы один продукт в состав'); return; }
  const doSave = () => {
    let tk = 0, tp = 0, tf = 0, tc = 0, tg = 0;
    fEditIngs.forEach(ing => { const m = ing.grams / 100; tk += ing.per100.k * m; tp += ing.per100.p * m; tf += ing.per100.f * m; tc += ing.per100.c * m; tg += ing.grams; S.lastGrams[ing.name] = ing.grams; });
    const cooked = fNoShrink ? (tg || 1) : (parseFloat(document.getElementById('fCookedInp').value) || tg || 1);
    const portionAll = document.getElementById('fPortionAllChk').checked;
    const portion = portionAll ? cooked : (parseFloat(document.getElementById('fPortionGramsInp').value) || 0);
    const m = cooked > 0 ? portion / cooked : 0;
    const k = n0(tk * m), p = n1(tp * m), f = n1(tf * m), c = n1(tc * m);
    if (cooked && !fNoShrink) S.lastGrams['готово:' + name] = cooked;
    const entry = { name, g: n0(portion), k, p, f, c, eaten: fEaten, ingredients: JSON.parse(JSON.stringify(fEditIngs)), cookedWeight: cooked, portionAll, noShrink: fNoShrink };
    // Remember the actual batch (quantities used + cooked weight + noShrink) under this
    // dish's name, so picking it again — e.g. to log the leftovers tomorrow — starts from
    // what you really made, not the dish database's generic base recipe (see selectFoodItem).
    S.lastRecipe[name] = { ingredients: entry.ingredients, cookedWeight: cooked, noShrink: fNoShrink };
    if (!S.foodLog[foodDate]) S.foodLog[foodDate] = { breakfast: [], lunch: [], dinner: [], snacks: [] };
    if (editingFood) {
      const { meal: em, idx: ei } = editingFood;
      if (S.foodLog[foodDate][em]) S.foodLog[foodDate][em].splice(ei, 1);
      editingFood = null;
    }
    if (!S.foodLog[foodDate][activeMeal]) S.foodLog[foodDate][activeMeal] = [];
    S.foodLog[foodDate][activeMeal].push(entry);
    save(true);
    closeSheet('shAddFood');
    renderFood();
    maybeRefreshHome();
  };
  if (S.archivedDays.includes(foodDate)) requireArchivePassword(doSave);
  else doSave();
}

// Close suggestion dropdowns when clicking outside them.
document.addEventListener('click', e => {
  if (!e.target.closest('#foodNameInp') && !e.target.closest('#foodSugg'))
    document.getElementById('foodSugg') && (document.getElementById('foodSugg').style.display = 'none');
  if (!e.target.closest('#fIngInp') && !e.target.closest('#fIngSugg'))
    document.getElementById('fIngSugg') && (document.getElementById('fIngSugg').style.display = 'none');
});
